export const formatCurrency = (amount, currencySymbol = "$") => {
  const numericAmount = Number(amount);
  const formattedAmount = Math.floor(numericAmount).toLocaleString("es-AR");

  if (currencySymbol === "USD") {
    return `USD ${formattedAmount}`;
  } else {
    return `$ ${formattedAmount}`;
  }
};

export const parseCurrency = currencyString => {
  const cleanedString = currencyString.replace(/[$. ]/g, "");
  const normalizedString = cleanedString.replace(",", ".");
  const number = parseFloat(normalizedString);
  return number.toFixed(2);
};

export const formatDate = date => {
  return date.split("-").reverse().join("/");
};
